export default "__VITE_ASSET__RoJcq7iM__"